<template>
  <CockpitDialog class="left-520px top-200px" title="阀门详情" @close="close">
    <el-form
      :model="formData"
      ref="detailForm"
      class="form-wrap pt-10px h-full overflow-y-auto overflow-x-hidden"
      label-width="100px"
      v-loading="formLoading"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="阀门名称" prop="name">
            <el-input v-model="formData.name" size="small" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="阀门编码" prop="code">
            <el-input v-model="formData.code" size="small" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-for="item in formAttributeList" :key="item.code">
          <el-form-item :label="item.name" prop="code">
            <el-input
              v-model="formData[`${item.tableName}.${item.columnName}`]"
              size="small"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </CockpitDialog>
</template>

<script>
import ResourceApiService from '../../../../service/ResourceApiService'

const CockpitDialog = () => {
  return import('@/components/cockpit/CockpitDialog')
}
export default {
  name: 'ValveDetail',
  props: {
    currentValve: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  watch: {
    'currentValve.code': {
      handler(newVal, oldVal) {
        if (oldVal) {
          this.getValveDetail()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.getValveDetail()
  },
  components: {
    CockpitDialog,
  },
  data() {
    return {
      formLoading: false,
      formData: {
        name: null,
        code: null,
      },
      formAttributeList: [],
    }
  },
  methods: {
    // 关闭阀门详情弹窗
    close() {
      this.$emit('closeGxDetail', 'currentValve')
    },
    async getValveDetail() {
      this.formLoading = true
      try {
        this.formAttributeList = this.$options.data().formAttributeList
        this.formData = this.$options.data().formData
        if (this.currentValve.classId) {
          const [err, res] = await ResourceApiService.getDynamicTableHeader({
            classId: this.currentValve.classId,
          })
          if (!err && res && res.code === 0 && res.data) {
            const attributeDetail = _.find(res.data, ['code', 'Code'])
            this.formAttributeList = _.filter(res.data, (item) => {
              return item.code !== 'Code' && item.code !== 'Name'
            })
            if (this.formAttributeList.length) {
              const [error, result] = await ResourceApiService.getDynamicTableData({
                classId: this.currentValve.classId,
                skipCount: 0,
                maxResultCount: 99,
                whereList: [],
                classAttributeId: attributeDetail.id,
                operator: 0,
                keywords: this.currentValve.code,
                Sorting: '',
              })
              if (!error && result && result.code === 0 && result.data?.length) {
                this.formData = Object.assign(this.formData, this.currentValve, result.data[0])
              }
            }
          }
          this.formLoading = false
        } else {
          this.formAttributeList = this.$options.data().formAttributeList
          this.formData = Object.assign(this.formData, this.currentValve)
          this.formLoading = false
        }
      } catch (error) {
        this.formLoading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
